// skipcq: JS-W1028
import Chip from '@mui/material/Chip';

function ReviewDetailsNewChip() {
  return (
    <Chip
      label="NEW"
      size="small"
      aria-label="New review"
      sx={{
        bgcolor: '#F9DA85',
        color: 'text.primary',
        fontWeight: 600,
        height: 22,
      }}
    />
  );
}

export default ReviewDetailsNewChip;
